<template>
  <div
    class="sidebar"
    :class="{ dark, mobile, 'absolute pin-t': dark && isMobile }"
  >
    <div
      v-if="mobile"
      class="absolute pin-r pin-t mt-2 mr-4"
      @click="$emit('close')"
    >
      X
    </div>
    <VueDraggableResizable
      :draggable="dark && !isMobile"
      :resizable="false"
      parent="#app"
      :y="isMobile && dark ? 0 : 150"
      :h="55"
      :w="dark ? darkMenuWidth : 162"
      class-name=""
    >
      <div
        v-if="dark"
        class="sidebar-header"
      >
        <ButtonBar
          @minimize="open = false"
          @maximize="open = true"
        />
        <div class="mb-2">///MENU_BAR</div>
        <div class="hidden sm:block">[24-567] 345605</div>
      </div>
      <div
        v-if="open"
        :class="{ 'bg-almost-black': dark }"
      >
        <SidebarItem
          v-for="item in sidebarItems"
          :key="item.label"
          :item="item"
          @click="close"
        />
      </div>
    </VueDraggableResizable>
  </div>
</template>
<script>
import VueDraggableResizable from 'vue-draggable-resizable'

import { mapState, mapGetters } from 'vuex'
import ButtonBar from './ButtonBar.vue'
import SidebarItem from './SidebarItem.vue'

export default {
  name: 'TheSidebar',

  components: {
    ButtonBar,
    VueDraggableResizable,
    SidebarItem,
  },

  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      open: true,
    }
  },

  computed: {
    ...mapState({
      dark: state => state.auth.dark,
    }),

    ...mapGetters({
      isMobile: 'global/isMobile',
      darkMenuWidth: 'global/darkMenuWidth',
      currentEpisode: 'auth/currentEpisode',
    }),

    sidebarItems() {
      return this.items.filter(item => (this.dark ? item.dark : !item.dark))
    },

    items() {
      return [
        {
          label: 'News',
          children: [
            { label: 'Polls', routeName: 'Polls' },
            { label: 'Forum', routeName: 'Forum' },
          ],
        },
        {
          label: 'Services',
          children: [
            { label: 'Maintenance', routeName: 'Maintenance' },
            { label: 'Hazmats', routeName: 'Hazmat' },
            { label: 'Rations', routeName: 'Rations' },
          ],
        },
        {
          label: 'Directory',
          children: [
            { label: 'Personnel Files', routeName: 'Personnel' },
            {
              label: 'Council Portal',
              routeName: this.currentEpisode > 4 ? 'CouncilPortal' : null,
            },
          ],
        },
        {
          label: 'Notes',
          children: [
            {
              label: 'Documents',
              routeName: 'Documents',
            },
            {
              label: 'Terminal',
              routeName: this.currentEpisode > 2 ? 'Terminal' : null,
            },
          ],
          dark: true,
        },
        {
          label: 'Investigation',
          children: [{ label: 'Case File', routeName: 'Investigation' }],
          dark: true,
        },
        {
          label: 'External Recon',
          children: [
            { label: 'TSS File', routeName: 'TSSFile' },
            {
              label: 'Virus Report',
              routeName: this.currentEpisode > 1 ? 'VirusReport' : null,
              zoomable: true,
            },
          ],
          dark: true,
        },
        {
          label: 'Internal Recon',
          children: [
            {
              label: 'AC Records',
              routeName: this.currentEpisode > 1 ? 'FrequenciesReceived' : null,
            },
            {
              label: 'Facility Map',
              routeName: this.currentEpisode > 2 ? 'Facility' : null,
              zoomable: true,
            },
          ],
          dark: true,
        },
        {
          label: 'Communication',
          routeName: this.currentEpisode > 1 ? 'Communication' : null,
          dark: true,
        },
      ]
    },
  },

  methods: {
    close() {
      if (this.isMobile && this.dark) {
        this.open = false
      }
      this.$emit('close')
    },
  },
}
</script>
<style lang="postcss" scoped>
.sidebar {
  width: 180px;
  box-shadow: 21px 21px 14px 0 rgba(0, 0, 0, 0.5);
  @apply bg-blue-darkest pt-16 z-40;

  &-header {
    height: 45px;
    font-family: 'input-mono';
    font-size: 12px;
    color: #020303;
    @apply bg-blue-light p-2;
  }

  &.dark {
    box-shadow: none;
    @apply absolute border border-blue pt-0;
  }

  &.mobile {
    @apply absolute h-full pin-l pin-t overflow-scroll;
  }

  &-item {
    height: 34px;
    font-family: 'univia-pro';
    font-size: 18px;
    padding-left: 21px;
    @apply text-blue my-4;
  }
}
</style>
